module.exports = __webpack_public_path__ + "img/alles.ebe93a57.svg";